export const FILE_TYPES_PDF = ["pdf", "md", "docx", "html", "txt"];
export const FILE_TYPE_IMAGE = ["png", "jpg", "jpeg", "jfif"];
export const FILE_TYPES_JSON = ["json"];
export const FILE_TYPES_EXCEL = ["xlsv", "xlsx"];
